export default "<p>\n  dashboard works!\n</p>\n";